// Der Einladungscode für den ersten Zugang (PLAN.md, Abschnitt 3,
// „Anmeldung“): Das Büro zeigt ihn an und gibt ihn persönlich weiter.
//
// Zehn Zeichen aus einem Alphabet ohne leicht verwechselbare Zeichen
// (Crockford: kein I, L, O, U) – rund 50 Bit Zufall. Zusammen mit der
// Login-Bremse (wenige Versuche je Viertelstunde), der Gültigkeit von sieben
// Tagen und „nur einmal einlösbar“ ist Raten aussichtslos.
// Angezeigt wird er in zwei Fünfergruppen: „K7M2Q-9XA4T“.

const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
export const EINLADUNGSCODE_LAENGE = 10;

/** Ein neuer, zufälliger Code ohne Bindestrich. */
export function neuerEinladungscode(): string {
  const zufall = new Uint8Array(EINLADUNGSCODE_LAENGE);
  globalThis.crypto.getRandomValues(zufall);
  // 256 ist ein Vielfaches von 32 – jedes Zeichen ist gleich wahrscheinlich.
  return Array.from(zufall, (b) => ALPHABET[b % 32]).join("");
}

/** So, wie ihn ein Mensch liest: zwei Fünfergruppen. */
export function einladungscodeAnzeigen(code: string): string {
  return `${code.slice(0, 5)}-${code.slice(5)}`;
}

/**
 * Was jemand eintippt, wird großzügig gelesen: klein oder groß, mit oder ohne
 * Leer- und Bindestrich; O wird zu 0, I und L zu 1. Ist danach kein gültiger
 * Code übrig, kommt `null` zurück.
 */
export function einladungscodeLesen(eingabe: string): string | null {
  const bereinigt = eingabe
    .toUpperCase()
    .replace(/[\s-]/g, "")
    .replace(/O/g, "0")
    .replace(/[IL]/g, "1");
  if (bereinigt.length !== EINLADUNGSCODE_LAENGE) return null;
  for (const zeichen of bereinigt) {
    if (!ALPHABET.includes(zeichen)) return null;
  }
  return bereinigt;
}
